import type {
  ResolutionDetailsContext as ResolutionDetailsContextType,
  ResolutionDetailsStepperContext as ResolutionDetailsStepperContextType
} from '@library/types/resolutions/resolutionDetails';
import {
  defaultFormattedResolutionDetails,
  defaultResolutionStepsWithStatus,
  initialNewResolution
} from '@bo-constants/resolutions/resolutionDetailsContexts';
import { createContext } from 'react';

export const ResolutionDetailsStepperContext =
  createContext<ResolutionDetailsStepperContextType>({
    currentResolutionStep: 1,
    onClickNextNewResolutionStep: () => {},
    resolutionSteps: defaultResolutionStepsWithStatus
  });

export const ResolutionDetailsContext =
  createContext<ResolutionDetailsContextType>({
    isLoading: false,
    isNewResolution: true,
    resolution: initialNewResolution,
    resolutionDetails: defaultFormattedResolutionDetails,
    resolutionDataFetchError: false
  });
